module.exports = __webpack_public_path__ + "img/GanttChart.69263ea7.png";